import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Megaphone, Shapes, HandCoins, Headset } from 'lucide-react';
import { DMDiv, DMText } from './Primitives';

interface DashboardSelectionProps {
  onSelect?: (view: 'main') => void;
}

export const DashboardSelection = ({ onSelect }: DashboardSelectionProps) => {
  const navigate = useNavigate();
  const cards = [
    {
      id: 'main',
      title: 'Digital Marketing Dashboard',
      description:
        'Manage campaigns, track enquiries, and grow your institution — all in one place.',
      icon: <Megaphone className="w-[8vh] h-[8vh] text-emerald-500" />,
      borderColor: 'hover:border-emerald-500/50',
    },
    {
      id: 'ai-teaching',
      title: 'AI Teaching – Student & Parent Excellence Engine',
      description:
        'A research-driven system strengthening student mindset, improving performance, and guiding parents effectively Through Podcasts.',
      icon: <Shapes className="w-[8vh] h-[8vh] text-orange-500" />,
      borderColor: 'hover:border-orange-500/50',
    },
    {
      id: 'fee-collection',
      title: 'AI Based Auto Fee Collection Dashboard',
      description:
        "From automated AI reminders to confirmed payments, one dashboard to accelerate your institution's cash flow.",
      icon: <HandCoins className="w-[8vh] h-[8vh] text-blue-500" />,
      borderColor: 'hover:border-blue-500/50',
    },
    {
      id: 'support',
      title: 'AI Support',
      description: "Your school's 24×7 smart helper.",
      icon: <Headset className="w-[8vh] h-[8vh] text-purple-500" />,
      borderColor: 'hover:border-purple-500/50',
    },
  ];

  return (
    <DMDiv className="flex-1 w-full flex flex-col items-center justify-center p-[2vh]">
      <DMDiv className="grid grid-cols-2 gap-[3vh] pt-[1vh] pb-[1vh] max-w-[120vh] w-full">
        {cards.map((card, idx) => (
          <DMDiv
            key={idx}
            onClick={() => {
              if (card.id === 'main') {
                navigate('/digital-marketing/dashboard');
              }
            }}
            className={`bg-white rounded-[3vh] border-2 border-gray-200 px-[6vh] py-[5vh] shadow-lg flex flex-col items-center justify-center text-center gap-[2vh] transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer ${card.borderColor}`}
          >
            <DMDiv className="mb-[1vh]">{card.icon}</DMDiv>
            <DMDiv className="space-y-[1.5vh]">
              <DMText
                as="h3"
                className="text-[2.6vh] font-bold text-gray-900 leading-tight"
              >
                {card.title}
              </DMText>
              <DMText className="text-[1.8vh] text-gray-500 leading-relaxed max-w-[45vh]">
                {card.description}
              </DMText>
            </DMDiv>
          </DMDiv>
        ))}
      </DMDiv>
    </DMDiv>
  );
};
